"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateFollowForce = exports.followTarget = void 0;
var app_1 = require("../../app");
var helpers_1 = require("../../helpers");
/**
 * @param {Object} options
 * @param {number} [options.followForce]
 * @param {number} [options.separation]
 * @param {number} [options.cohesion]
 * @param {number} [options.alignment]
 * @param {number} [options.maxSpeed]
 */
var followTarget = function (sprite, target, speed, delta, options) { return __awaiter(void 0, void 0, void 0, function () {
    var sprites, targetX, targetY, forces, totalForceX, totalForceY, totalForceNormalized, magnitude, scale;
    return __generator(this, function (_a) {
        sprites = app_1.gameState.allUnits;
        targetX = target.x, targetY = target.y;
        forces = {
            follow: { x: 0, y: 0 },
            separation: { x: 0, y: 0 },
            cohesion: { x: 0, y: 0 },
            alignment: { x: 0, y: 0 },
        };
        if ((options === null || options === void 0 ? void 0 : options.followForce) > 0) {
            forces.follow = (0, exports.calculateFollowForce)({ targetX: targetX, targetY: targetY }, sprite);
            forces.follow.x *= options.followForce;
            forces.follow.y *= options.followForce;
        }
        if (options === null || options === void 0 ? void 0 : options.separation) {
            forces.separation = calculateSeparationForce(sprite, sprites, 0);
            forces.separation.x *= options.separation;
            forces.separation.y *= options.separation;
        }
        if (options === null || options === void 0 ? void 0 : options.cohesion) {
            forces.cohesion = calculateCohesionForce(sprite, sprites, 200);
            forces.cohesion.x *= options.cohesion;
            forces.cohesion.y *= options.cohesion;
        }
        if (options === null || options === void 0 ? void 0 : options.alignment) {
            forces.alignment = calculateAlignmentForce(sprite, sprites, 400);
            forces.alignment.x *= options.alignment;
            forces.alignment.y *= options.alignment;
        }
        totalForceX = forces.follow.x + forces.separation.x + forces.alignment.x + forces.cohesion.x;
        totalForceY = forces.follow.y + forces.separation.y + forces.alignment.y + forces.cohesion.y;
        totalForceNormalized = (0, helpers_1.normalizeForce)({ x: totalForceX, y: totalForceY });
        sprite.vx += totalForceNormalized.x * speed * delta;
        sprite.vy += totalForceNormalized.y * speed * delta;
        // friction
        sprite.vx *= 0.95;
        sprite.vy *= 0.95;
        // Limit maximum speed
        if ((options === null || options === void 0 ? void 0 : options.maxSpeed) > 0) {
            magnitude = Math.sqrt(sprite.vx * sprite.vx + sprite.vy * sprite.vy);
            if (magnitude > options.maxSpeed) {
                scale = options.maxSpeed / magnitude;
                sprite.vx *= scale;
                sprite.vy *= scale;
            }
        }
        sprite.x += sprite.vx;
        sprite.y += sprite.vy;
        return [2 /*return*/];
    });
}); };
exports.followTarget = followTarget;
var calculateFollowForce = function (_a, sprite) {
    var targetX = _a.targetX, targetY = _a.targetY;
    var followForce = { x: 0, y: 0 };
    var dx = targetX - sprite.x;
    var dy = targetY - sprite.y;
    var distance = Math.sqrt(dx * dx + dy * dy);
    if (distance > 0) {
        var directionX = dx / distance;
        var directionY = dy / distance;
        followForce.x = directionX;
        followForce.y = directionY;
    }
    return followForce;
};
exports.calculateFollowForce = calculateFollowForce;
/*
const generateSymmetricKey = (index1, index2) => {
  const [ first, second ] = [index1, index2].sort();
  return `${first}-${second}`;
}
*/
// raycast at 4 points and if an overlap is detected apply separation force?
var calculateSeparationForce = function (sprite, flock, maxOverlapRatio) {
    var separationForce = { x: 0, y: 0 };
    // const index = flock.findIndex(s => s === sprite);
    flock.forEach(function (unit, i) {
        var otherSprite = unit;
        if (!otherSprite.destroyed && otherSprite !== sprite) {
            /*
            const id = generateSymmetricKey(index, i);
            if (gameState.separationForceCache.has(id)) {
              return gameState.separationForceCache.get(id);
            }
            */
            var dx = otherSprite.x - sprite.x;
            var dy = otherSprite.y - sprite.y;
            var distance = dx * dx + dy * dy;
            // check for collision
            var minDistance = sprite.width / 2 + otherSprite.width / 2;
            if (distance < Math.pow(minDistance, 2)) {
                distance = Math.sqrt(distance);
                var overlapRatio = (minDistance - distance) / minDistance;
                if (overlapRatio > maxOverlapRatio) {
                    var separationDirectionX = dx / distance;
                    var separationDirectionY = dy / distance;
                    separationForce.x -= separationDirectionX;
                    separationForce.y -= separationDirectionY;
                }
            }
            // gameState.separationForceCache.set(id, separationForce);
        }
    });
    return separationForce;
};
var calculateCohesionForce = function (sprite, flock, cohesionRadius) {
    var cohesionForce = { x: 0, y: 0 };
    var neighbors = [];
    flock.forEach(function (otherSprite) {
        if (otherSprite !== sprite) {
            var dx = otherSprite.x - sprite.x;
            var dy = otherSprite.y - sprite.y;
            var distance = dx * dx + dy * dy;
            if (distance < Math.pow(cohesionRadius, 2)) {
                neighbors.push(otherSprite);
            }
        }
    });
    if (neighbors.length > 0) {
        // Calculate average position of neighbors
        var avgPosition = neighbors.reduce(function (acc, neighbor) {
            acc.x += neighbor.x;
            acc.y += neighbor.y;
            return acc;
        }, { x: 0, y: 0 });
        avgPosition.x /= neighbors.length;
        avgPosition.y /= neighbors.length;
        // Calculate cohesion force towards the average position
        cohesionForce.x = avgPosition.x - sprite.x;
        cohesionForce.y = avgPosition.y - sprite.y;
    }
    return cohesionForce;
};
var calculateAlignmentForce = function (sprite, flock, alignmentRadius) {
    var alignmentForce = { x: 0, y: 0 };
    var neighbors = [];
    flock.forEach(function (otherSprite) {
        if (otherSprite !== sprite) {
            var dx = otherSprite.x - sprite.x;
            var dy = otherSprite.y - sprite.y;
            var distance = dx * dx + dy * dy;
            if (distance < Math.pow(alignmentRadius, 2)) {
                neighbors.push(otherSprite);
            }
        }
    });
    if (neighbors.length > 0) {
        // Calculate average velocity of neighbors
        var avgVelocity = neighbors.reduce(function (acc, neighbor) {
            acc.x += neighbor.vx;
            acc.y += neighbor.vy;
            return acc;
        }, { x: 0, y: 0 });
        avgVelocity.x /= neighbors.length;
        avgVelocity.y /= neighbors.length;
        // Calculate alignment force towards the average velocity
        alignmentForce.x = avgVelocity.x - sprite.vx;
        alignmentForce.y = avgVelocity.y - sprite.vy;
    }
    return alignmentForce;
};
